import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { MultiSelect } from "react-multi-select-component";

import { add_sticker_store, get_country_data, get_region_data, update_sticker_store } from '../../../Controller/actions';
import { NewContext } from '../../../Context/NewContext';

import './stickerstoreform.css';

export const StickerStoreForm = ({ title }) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { isLoading, setIsLoading, validated, setValidated, updatedData, setUpdatedData, capitalalizeFirstletter, updateStateAryData } = useContext(NewContext);
    const [stickersStore, setStickersStore] = useState({
        name: state ? state.name : "",
        country: state ? state.country : [],
        region: state ? state.region : [],
        isLock: state ? state.isLock == undefined ? false : state.isLock : false,
        isLatest: state ? state.isLatest == undefined ? false : state.isLatest : false,
        isPremium: state ? state.isPremium == undefined ? false : state.isPremium : false,
        isActive: state ? state.isActive == undefined ? false : state.isActive : false,
    });
    const [imgObj, setImgObj] = useState({
        previewStickerStore: state ? state.preview : "",
        // smallPreviewStickerStore: state ? state.smallPreview : "",
        bigPreviewStickerStore: state ? state.bigPreview : "",
        stickerZip: state ? state.stickerZip : ""
    });
    const [country, setCountry] = useState([]);
    const [region, setRegion] = useState([]);

    const [multiThemeCountry, setMultiThemeCountry] = useState([]);
    const [multiThemeRegion, setMultiThemeRegion] = useState([]);

    const getTagFunc = async () => {
        try {
            const countryData = await get_country_data();
            const regionData = await get_region_data();
            if (countryData.status && regionData.status) {
                countryData.data.map(_ele => setCountry(_prev => [..._prev, { value: _ele.code, label: capitalalizeFirstletter(_ele.name), name: 'country' }]))
                regionData.data.map(_ele => setRegion(_prev => [..._prev, { value: _ele.name.toLowerCase(), label: capitalalizeFirstletter(_ele.name), name: 'region' }]))
                if (state) {
                    let oldCountryData = updateStateAryData(state?.country, countryData.data, 'country');
                    let oldRegionData = updateStateAryData(state?.region, regionData.data, 'region');
                    setMultiThemeCountry(oldCountryData);
                    setMultiThemeRegion(oldRegionData);
                }
            } else {
                console.log(countryData.message || regionData.message);
            }
        } catch (error) {
            console.error(error);
        };
    };

    const handleChange = (e) => {
        if (e.target.name === "country" || e.target.name === "region") {
            let stickersStoreCountryAry = [].slice.call(e.target.selectedOptions).map(item => item.value);
            setUpdatedData({ ...updatedData, [e.target.name]: stickersStoreCountryAry })
            setStickersStore({ ...stickersStore, [e.target.name]: stickersStoreCountryAry });
        } else {
            setUpdatedData({ ...updatedData, [e.target.name]: e.target.value })
            setStickersStore({ ...stickersStore, [e.target.name]: e.target.value });
        }
    };
    const handleSelectMultiThemeCountry = (e) => {
        if (e.length > 0) {
            e.map(_ele => {
                let themeMultiSelectAry = [].slice.call(e).map(item => item.value);
                if (_ele.name === 'country') {
                    setMultiThemeCountry(e);
                    setUpdatedData({ ...updatedData, [_ele.name]: themeMultiSelectAry })
                    setStickersStore({ ...stickersStore, [_ele.name]: themeMultiSelectAry });
                }
            })
        } else {
            setMultiThemeCountry([]);
            setUpdatedData({ ...updatedData, country: [] })
            setStickersStore({ ...stickersStore, country: [] });
        }
    }
    const handleSelectMultiThemeRegion = (e) => {
        if (e.length > 0) {
            e.map(_ele => {
                let themeMultiSelectAry = [].slice.call(e).map(item => item.value);
                if (_ele.name === 'region') {
                    // console.log(themeMultiSelectAry, '====>>>> region');
                    // console.log(e, '====>>>> region');
                    setMultiThemeRegion(e);
                    setUpdatedData({ ...updatedData, [_ele.name]: themeMultiSelectAry })
                    setStickersStore({ ...stickersStore, [_ele.name]: themeMultiSelectAry });
                }
            })
        } else {
            setMultiThemeRegion([]);
            setUpdatedData({ ...updatedData, region: [] })
            setStickersStore({ ...stickersStore, region: [] });
        }
    }

    const handleFileInput = (e) => {
        // console.log(e.target.name, '====name====')
        // console.log(e.target.files, '=====files=====');
        if (e.target.name == "bigPreviewStickerStore") {
            let bigPreviewAry = [];
            let blobURLS = []
            for (let key of e.target.files) {
                bigPreviewAry.push(key);
                blobURLS.push(URL.createObjectURL(key));
            }
            setImgObj({ ...imgObj, [e.target.name]: blobURLS });
            setUpdatedData({ ...updatedData, name: stickersStore.name, [e.target.name]: bigPreviewAry })
            setStickersStore({ ...stickersStore, [e.target.name]: bigPreviewAry });
        } else {
            // if (e.target.files[0].size > 5242880) {
            //     toast.error(`${e.target.name.charAt(0).toUpperCase() + e.target.name.slice(1)} must less than 5 MB!`);
            // } else {
            setImgObj({ ...imgObj, [e.target.name]: URL.createObjectURL(e.target.files[0]) });
            setUpdatedData({ ...updatedData, name: stickersStore.name, [e.target.name]: e.target.files[0] })
            setStickersStore({ ...stickersStore, [e.target.name]: e.target.files[0] });
            // } 
        }
    };
    // console.log(stickersStore, '====stickersStore====');
    let handleSwitch = (e) => {
        setUpdatedData({ ...updatedData, [e.target.name]: stickersStore[e.target.name] ? false : true });
        setStickersStore({ ...stickersStore, [e.target.name]: stickersStore[e.target.name] ? false : true });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return;
        };
        let createUpdateStickersStore;
        setIsLoading(true);
        if (state) {
            createUpdateStickersStore = await update_sticker_store({ ...updatedData, country: stickersStore.country, region: stickersStore.region }, state._id);
        } else {
            // console.log("==========stickersStore==========", stickersStore);
            createUpdateStickersStore = await add_sticker_store(stickersStore)
        }
        setIsLoading(false);
        if (createUpdateStickersStore) {
            const { message, status } = createUpdateStickersStore;
            if (status) {
                toast.success(message);
                navigate("/stickerstore");
                setStickersStore({
                    name: "",
                    country: [],
                    region: [],
                    isLock: false,
                    isLatest: false,
                    isPremium: false,
                    isActive: false,
                });
                setImgObj({
                    previewStickerStore: "",
                    smallPreviewStickerStore: "",
                    bigPreviewStickerStore: "",
                    stickerZip: "",
                });
                setUpdatedData({});
                setValidated(false);
            } else {
                toast.error(message);
            };
        }
    };

    useEffect(() => {
        getTagFunc();
    }, [])

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`;
        setUpdatedData({});
    }, []);

    return (
        <div className='addslider-main p-3'>
            <div className='sliders-header mb-3 d-flex justify-content-between'>
                <h3>{state ? `Edit Sticker Store` : `Add Sticker Store`}</h3>
            </div>
            <Row>
                <Col lg={3} md={4} sm={6} className="mb-3 mx-auto">
                    <Row className='flex-column'>
                        <Col className='mb-3'>
                            <h6 className='mb-1'>Preview : </h6>
                            <img className='w-100' src={`${imgObj.previewStickerStore ? imgObj.previewStickerStore : `../../../assets/images/no-image.png`}`} alt={updatedData.name ? updatedData.name : stickersStore.name} />
                        </Col>
                        {/* <Col className='mb-3'>
                            <h6 className='mb-1'>Small Preview : </h6>
                            <img className='w-50' src={`${imgObj.smallPreviewStickerStore ? `${imgObj.smallPreviewStickerStore}` : `../../../assets/images/no-image.png`}`} alt={stickersStore.name} />
                        </Col> */}
                        {
                            !state &&
                            <Col className='mb-3'>
                                <h6 className='mb-1'>Big Preview : </h6>
                                {
                                    imgObj.bigPreviewStickerStore ? imgObj.bigPreviewStickerStore.map((_ele) => (
                                        <img className='w-100 mb-2 d-block' src={`${_ele ? `${_ele}` : `../../../assets/images/no-image.png`}`} alt={updatedData.name ? updatedData.name : stickersStore.name} />
                                    )) : <img className='w-100 mb-2 d-block' src={`../../../assets/images/no-image.png`} alt={"No Image"} />
                                }
                            </Col>
                        }
                    </Row>
                </Col>
                <Col md={8} lg={9}>
                    <Form noValidate validated={validated} onSubmit={handleSubmit} method="POST">
                        <Row className='mb-3'>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='stickersStore_name' column md={3} sm={4}>Name</Form.Label>
                                <Col><Form.Control id='stickersStore_name' type="text" placeholder="Enter name" name='name' onChange={handleChange} value={updatedData.name ? updatedData.name : stickersStore.name} required /></Col>
                            </Col>
                            {/* <Col lg={6} className="mb-3">            
                                    <Form.Label htmlFor='stickersStore_thumbType' column md={3} sm={4}>Thumb Type</Form.Label>
                                    <Col><Form.Control id='stickersStore_thumbType' type="text" placeholder="Enter Thumb Type" name='thumbType' onChange={handleChange} value={stickersStore.thumbType} /></Col>                              
                            </Col> */}
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='stickersStore_previewStickerStore' column md={3} sm={4}>Preview</Form.Label>
                                <Col><Form.Control id='stickersStore_previewStickerStore' type="file" accept='image/*' name='previewStickerStore' onChange={handleFileInput} required={state ? false : true} /></Col>
                            </Col>
                            {/* <Col lg={6} className="mb-3">                          
                                    <Form.Label htmlFor='stickersStore_smallPreviewStickerStore' column md={3} sm={4}>Small Preview</Form.Label>
                                    <Col><Form.Control id='stickersStore_smallPreviewStickerStore' type="file" accept='image/*' name='smallPreviewStickerStore' onChange={handleFileInput} /></Col>                          
                            </Col> */}
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='stickersStore_bigPreviewStickerStore' column md={3} sm={4}>Big Preview</Form.Label>
                                <Col><Form.Control multiple id='stickersStore_bigPreviewStickerStore' type="file" accept='image/*' name='bigPreviewStickerStore' onChange={handleFileInput} required={state ? false : true} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='theme_stickerZip' column md={3} sm={4}>Sticker Zip</Form.Label>
                                <Col><Form.Control id='theme_stickerZip' type="file" name='stickerZip' accept='application/x-zip-compressed' onChange={handleFileInput} required={state ? false : true} /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='stickersStore_country' column md={3} sm={4}>Country</Form.Label>
                                <Col>
                                    {/* <Form.Select multiple name='country' onChange={handleChange} value={updatedData.country ? updatedData.country : stickersStore.country} required>
                                        <option value={""} className='text-muted'>Select Countries</option>
                                        {country?.map((_ele, i) => <option key={i} value={_ele.code}>{_ele.name}</option>)}
                                    </Form.Select> */}
                                    {
                                        country && country.length > 0 &&
                                        <MultiSelect
                                            options={country}
                                            value={multiThemeCountry}
                                            onChange={handleSelectMultiThemeCountry}
                                            hasSelectAll={true}
                                            ClearSelectedIcon={null}
                                        />
                                    }
                                </Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='stickersStore_region' column md={3} sm={4}>Region</Form.Label>
                                <Col>
                                    {/* <Form.Select multiple name='region' onChange={handleChange} value={updatedData.region ? updatedData.region : stickersStore.region} required>
                                        <option value={""} className='text-muted'>Select Regions</option>
                                        {region?.map((_ele, i) => <option key={i} value={_ele.name.toLowerCase()}>{_ele.name}</option>)}
                                    </Form.Select> */}
                                    {
                                        region && region.length > 0 &&
                                        <MultiSelect
                                            options={region}
                                            value={multiThemeRegion}
                                            onChange={handleSelectMultiThemeRegion}
                                            hasSelectAll={true}
                                            ClearSelectedIcon={null}
                                        />
                                    }
                                </Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='stickersStore_isLock' column md={3} sm={4}>Lock</Form.Label>
                                <Col><Form.Check type="switch" id="stickersStore_isLock" name='isLock' onChange={handleSwitch} checked={stickersStore.isLock} role="button" /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='stickersStore_isLatest' column md={3} sm={4}>Latest</Form.Label>
                                <Col><Form.Check type="switch" id="stickersStore_isLatest" name='isLatest' onChange={handleSwitch} checked={stickersStore.isLatest} role="button" /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='stickersStore_isPremium' column md={3} sm={4}>Premium</Form.Label>
                                <Col><Form.Check type="switch" id="stickersStore_isPremium" name='isPremium' onChange={handleSwitch} checked={stickersStore.isPremium} role="button" /></Col>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <Form.Label htmlFor='stickersStore_isActive' column md={3} sm={4}>Active</Form.Label>
                                <Col><Form.Check type="switch" id="stickersStore_isActive" name='isActive' onChange={handleSwitch} checked={stickersStore.isActive} role="button" /></Col>
                            </Col>
                        </Row>
                        <Row className='justify-content-end'>
                            <Col lg={12}>
                                <Col lg={3} md={3} sm={4}></Col>
                                <Col>
                                    <Button variant="primary" type="submit" className='px-5 me-3' style={{ width: "150px" }}>
                                        {isLoading ? <Spinner animation="border" size="sm" /> : state ? `Update` : `Submit`}
                                    </Button>
                                    {/* <Link to=""> */}
                                    <Button variant="danger" className='w-auto px-5' onClick={() => navigate(-1)}>{`Back`}</Button>
                                    {/* </Link> */}
                                </Col>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
};

StickerStoreForm.defaultProps = {
    title: "Sticker Store Form"
};

export default StickerStoreForm;